import { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import Sidebar from './Sidebar'
import clsx from 'clsx'
import { languageUtil } from '../../util/languageUtils'

function AdminLayout() {
    const navigate = useNavigate()
    const [checkingAuth, setCheckingAuth] = useState(true)
    const [isSidebarMinimized, setIsSidebarMinimized] = useState(false)
    const { language } = languageUtil()
    const isRTL = language === 'ar'

    useEffect(() => {
        const token = localStorage.getItem('token')
        const adminData = localStorage.getItem('adminData')

        if (!token || !adminData) {
            navigate('/admin/login', { replace: true })
        } else {
            setCheckingAuth(false)
        }
    }, [navigate])

    if (checkingAuth) {
        return (
            <div className='flex items-center justify-center w-full h-screen'>
                <span className='text-gray-500'>Checking authentication...</span>
            </div>
        )
    }

    return (
        <div className='flex overflow-y-auto max-h-vh'>
            <Sidebar onToggleMinimize={setIsSidebarMinimized} />
            <main
                className={clsx(
                    'flex-1 p-4 transition-all duration-300',
                    isSidebarMinimized ? (isRTL ? 'mr-14' : 'ml-14') : isRTL ? 'mr-72' : 'ml-72'
                )}
            >
                <Outlet />
            </main>
        </div>
    )
}

export default AdminLayout
